import React from "react";
import { lazy } from "react";
import {
	ThemeProvider,
	StyledEngineProvider,
	createTheme,
} from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { Route, Routes, DefaultRoute } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
const Homepage = lazy(() => import("../Homepage/Homepage"));
const Analytics = lazy(() => import("../Analytics/AnalyticsPage"));
const innerTheme = createTheme({
	MuiChip: {
		root: {
			backgroundColor: "#181828",
		},
	},
	typography: {
		h6: { fontWeight: "400", fontSize: "1rem" },
		fontFamily: "soleil",
	},

	overrides: {
		PrivateTabIndicator: {
			root: {
				backgroundColor: "green",
			},
		},
		palette: {
			primary: {
				main: "##181828",
			},
			secondary: {
				main: "#F0F0F0",
				light: "#2FAFC4",
			},
		},
		MuiListItemIcon: { root: { fill: "#77A6F6" } },
	},
});

export default function ButtonAppBar(props) {
	const buffering = (
		<div>
			<CircularProgress />
		</div>
	);

	return (
		<StyledEngineProvider injectFirst>
			<ParallaxProvider>
				<ThemeProvider theme={innerTheme}>
					<Routes>
						<Route
							path='/'
							element={
								<React.Suspense fallback={buffering}>
									<Homepage />
								</React.Suspense>
							}
							exact
						/>
						<Route
							path='/analytics/*'
							element={
								<React.Suspense fallback={buffering}>
									<Analytics />
								</React.Suspense>
							}
						/>
						<Route
							path='*'
							element={
								<React.Suspense fallback={buffering}>
									<Homepage />
								</React.Suspense>
							}
						/>
					</Routes>
				</ThemeProvider>
			</ParallaxProvider>
		</StyledEngineProvider>
	);
}
